import { buscarEndereco, downloadFile } from '../../services/appservice'

const app = {
  state: {
    endereco: {},
    colors: {
      base: '#8D6E63',
      complementar: '#26A69A'
    }
  },

  mutations: {
    ADD_ENDERECO: (state, value) => {
      state.endereco = value
    }
  },

  actions: {
    BuscarEndereco ({ commit }, cep) {
      return new Promise((resolve, reject) => {
        buscarEndereco(cep).then(response => {
          commit('ADD_ENDERECO', response.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    DownloadFile ({ commit }, param) {
      return new Promise((resolve, reject) => {
        downloadFile(param.id).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', param.nome + param.tipo)
          document.body.appendChild(link)
          link.click()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/appmodule.js